import React from 'react';
import './Suite.css';

const Suite = () => {
  return (
    <div className="suite-container">
      <section className="suite-hero">
        <div className="container">
          <h1>La Suite Prosperian™ : vos leviers d'accélération commerciale activables à la carte</h1>
          <p className="suite-description">
            La Suite Prosperian est une architecture modulaire et évolutive pensée pour maximiser la performance de votre prospection B2B. 
            Chaque levier peut être activé indépendamment ou combiné, selon votre niveau de maturité, vos objectifs et les recommandations 
            issues de notre scoring propriétaire.
          </p>
          <p className="suite-intro">
            Découvrez ci-dessous les 13 leviers de la Suite, répartis en 3 grandes familles : Prospection, Conversion et Communication.
          </p>
        </div>
      </section>

      <section className="suite-section" id="prospection">
        <div className="container">
          <div className="section-header">
            <span className="section-number">1.</span>
            <h2>PROSPECTION — Captez l'attention de vos cibles</h2>
            <p className="section-intro">6 leviers pour générer des leads qualifiés avec un ciblage fin, multicanal et personnalisé.</p>
          </div>

          <div className="levers-grid">
            <div className="lever-card">
              <h3>Emailing</h3>
              <div className="lever-content">
                <h4>Mail</h4>
                <p>Campagnes d'emailing personnalisées et séquencées, optimisées pour l'ouverture et la réponse. Un levier stratégique pour les phases de considération.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Video Mail</h3>
              <div className="lever-content">
                <p>Des messages vidéos intégrés aux emails, humanisent votre démarche et augmentent jusqu'à +40% les taux de réponse sur certains segments.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>LinkedIn</h3>
              <div className="lever-content">
                <h4>Document Ads</h4>
                <p>Publicités natives sponsorisées avec contenu à forte valeur (guide, infographie, livre blanc). Un levier efficace pour générer des leads opt-in.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Message</h3>
              <div className="lever-content">
                <p>Séquences de messages directs et contextualisés à vos ICP sur LinkedIn. Copywriting expert + segmentation comportementale.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Audio Message</h3>
              <div className="lever-content">
                <p>Format différenciant, idéal pour les secteurs à forte proximité relationnelle. Humanise le premier contact, capte l'attention.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Video Message</h3>
              <div className="lever-content">
                <p>Messages LinkedIn vidéo pour rompre la monotonie des approches textuelles. Taux d'engagement supérieurs à 25% en moyenne.</p>
              </div>
            </div>
          </div>

          <div className="cta-container">
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer" className="cta-button">PRENDRE RENDEZ-VOUS</a>
            <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer" className="cta-button">DEMANDER UN DEVIS</a>
          </div>
        </div>
      </section>

      <section className="suite-section" id="conversion">
        <div className="container">
          <div className="section-header">
            <span className="section-number">2.</span>
            <h2>CONVERSION — Accélérez vos opportunités</h2>
            <p className="section-intro">4 modules pour qualifier vos leads, fluidifier vos parcours et générer plus de rendez-vous qualifiés.</p>
          </div>

          <div className="levers-grid">
            <div className="lever-card">
              <h3>Agent commercial connecté</h3>
              <div className="lever-content">
                <p>Un agent IA connecté à votre CRM et aux sources publiques en ligne, capable d'agréger et synthétiser toutes les données disponibles sur un prospect, son entreprise, son historique de contact ou son secteur. Objectif : arriver en rendez-vous ultra-préparé, avec une connaissance fine du contexte pour maximiser vos chances de conversion.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Profiling des prospects</h3>
              <div className="lever-content">
                <p>Identification dynamique des comportements et des profils psychologiques des prospects. L'analyse avancée des données comportementales et contextuelles permet une hyper-personnalisation des interactions, en fournissant à vos équipes un maximum d'insights pour mieux comprendre, engager et convaincre chaque contact.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Agent conversationnel (réception d'appel)</h3>
              <div className="lever-content">
                <p>Un agent vocal IA qui prend en charge vos appels entrants, filtre, qualifie et oriente intelligemment les demandes. Ce module vous fait gagner un temps précieux tout en assurant un traitement professionnel, rapide et contextualisé des opportunités entrantes ou des demandes d'information.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Prise de rendez-vous téléphonique</h3>
              <div className="lever-content">
                <p>Module de prise de RDV externalisée, synchronisé avec vos agendas. Nous appelons, filtrons et bookons uniquement les prospects qualifiés pour vos commerciaux, avec gestion proactive des relances.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="suite-section" id="communication">
        <div className="container">
          <div className="section-header">
            <span className="section-number">3.</span>
            <h2>COMMUNICATION — Cultivez la visibilité et la confiance</h2>
            <p className="section-intro">3 leviers complémentaires pour nourrir votre autorité, générer des signaux d'expertise et engager vos communautés.</p>
          </div>

          <div className="levers-grid">
            <div className="lever-card">
              <h3>Veille</h3>
              <div className="lever-content">
                <p>Nous collectons, trions et contextualisons les contenus pertinents pour votre cible. Objectif : alimenter vos prises de parole et renforcer votre positionnement.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Posts LinkedIn</h3>
              <div className="lever-content">
                <p>Rédaction et publication de contenus experts sur votre profil ou page entreprise : insights sectoriels, cas clients, micro-formats pédagogiques.</p>
              </div>
            </div>

            <div className="lever-card">
              <h3>Commentaires LinkedIn</h3>
              <div className="lever-content">
                <p>Engagement actif et stratégique sur les publications de vos prospects, partenaires ou influenceurs du secteur. Un levier souvent sous-estimé pour accroître la visibilité et amorcer des conversations.</p>
              </div>
            </div>
          </div>

          <div className="cta-container">
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer" className="cta-button">PRENDRE RENDEZ-VOUS</a>
            <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer" className="cta-button">DEMANDER UN DEVIS</a>
          </div>
        </div>
      </section>

      <section className="suite-score">
        <div className="container">
          <h2>Une activation sur-mesure, selon votre score Prosperian™</h2>
          <p>
            Chaque entreprise est unique. C'est pourquoi l'activation des leviers est personnalisée en fonction de votre Prosperian Score™, 
            qui mesure votre maturité commerciale selon 7 dimensions clés.
          </p>
          <p>
            Grâce à cette analyse initiale, nous déterminons les leviers les plus pertinents à activer en priorité, 
            puis déployons la suite complète de manière progressive pour maximiser votre ROI.
          </p>

          <div className="results-container">
            <h3>Résultat ? Une machine d'acquisition calibrée pour votre marché</h3>
            
            <div className="results-grid">
              <div className="result-card">
                <h4>+210%</h4>
                <p>d'opportunités qualifiées générées en 3 mois</p>
              </div>
              
              <div className="result-card">
                <h4>-40%</h4>
                <p>de coût d'acquisition moyen</p>
              </div>
              
              <div className="result-card">
                <h4>Cycle de vente</h4>
                <p>raccourci de 35%</p>
              </div>
              
              <div className="result-card">
                <h4>+3x</h4>
                <p>plus de rendez-vous avec décideurs</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Suite; 